import { toSafeUrl } from '@karakuri-web/common/utils'

interface Props {
  src?: string
  link?: string
  alt?: string
}
export function Brand({ src, link, alt }: Props) {
  const brand = src ? <img src={src} alt={alt} data-testid="faq-logo" /> : alt
  const href = toSafeUrl(link)

  return (
    <>
      {href ? (
        <a href={href} data-testid="faq-logo-link">
          {brand}
        </a>
      ) : (
        brand
      )}
    </>
  )
}
